import { z } from 'zod';
import { MediaItemSchema } from "../../api/media-item-schema";
import { ApiResponseSchema } from "../../api/api-response-schema";

export const TeamSchema = z.object({
  id: z.number(),
  full_name: z.string().nullable(),
  specialization: z.string().nullable(),
  foto1: MediaItemSchema.nullable().optional(),
  foto2: MediaItemSchema.nullable().optional()
});

export type Team = z.infer<typeof TeamSchema>;
const TeamPreviewArraySchema = z.array(TeamSchema);

export type TeamResponse = z.infer<typeof TeamResponseSchema>;


export const TeamResponseSchema = ApiResponseSchema(
  z.array(TeamSchema),
);

export type TeamSchemaKey = keyof typeof TeamSchema.shape;

export const TeamParams = <const>{
  populate: <TeamSchemaKey[]>['foto1', 'foto2'],
  fields: <TeamSchemaKey[]>[
    'id',
    'full_name',
    'specialization'
  ],
};
